import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import { fmtNumber } from './adminFormat';

/**
 * Email campaigns: how many were sent per campaign and which links were clicked.
 * `emailsSent` = [{ campaign, count }], `emailsClicked` = [{ campaignId, urlClicked, count }].
 */
const EmailStatsTable = ({ emailsSent, emailsClicked }) => {
    const sent = emailsSent || [];
    const clicked = emailsClicked || [];
    if (sent.length === 0 && clicked.length === 0) {
        return <Typography color="textSecondary">No email campaigns recorded.</Typography>;
    }

    // One row per campaign; clicks are listed per URL under it.
    const campaigns = {};
    sent.forEach((row) => {
        campaigns[row.campaign] = campaigns[row.campaign] || { sent: 0, clicks: [] };
        campaigns[row.campaign].sent += Number(row.count) || 0;
    });
    clicked.forEach((row) => {
        campaigns[row.campaignId] = campaigns[row.campaignId] || { sent: 0, clicks: [] };
        campaigns[row.campaignId].clicks.push(row);
    });

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>Campaign</TableCell>
                    <TableCell align="right">Sent</TableCell>
                    <TableCell>Clicked URL</TableCell>
                    <TableCell align="right">Clicks</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {Object.keys(campaigns).map((id) => {
                    const c = campaigns[id];
                    const totalClicks = c.clicks.reduce((sum, row) => sum + (Number(row.count) || 0), 0);
                    return (
                        <React.Fragment key={id}>
                            <TableRow>
                                <TableCell>{id}</TableCell>
                                <TableCell align="right">{fmtNumber(c.sent)}</TableCell>
                                <TableCell>{c.clicks.length ? `${c.clicks.length} link(s)` : '—'}</TableCell>
                                <TableCell align="right">{fmtNumber(totalClicks)}</TableCell>
                            </TableRow>
                            {c.clicks.map((row, i) => (
                                <TableRow key={`${id}-${i}`}>
                                    <TableCell />
                                    <TableCell />
                                    <TableCell style={{ wordBreak: 'break-all' }}>{row.urlClicked}</TableCell>
                                    <TableCell align="right">{fmtNumber(row.count)}</TableCell>
                                </TableRow>
                            ))}
                        </React.Fragment>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default EmailStatsTable;
